var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ty-img",on:{"click":_vm.clickHandler}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.lazyImgObj),expression:"lazyImgObj"}],attrs:{"width":"40"}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.name)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4139c9d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ty-img/TyImg.vue
// module id = 238
// module chunks = 0